<template>
  <a-table :columns="columns" :data-source="data" bordered size="small" :pagination="false"
    :locale="{ emptyText: '暂无数据' }" :scroll="{ x: 'calc(700px + 50%)', y: height }" />
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "OrderCalcStatistics",
  data() {
    return {
      data: [],
      columns: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {
  },
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 280;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 280;
    };
  },
  methods: {
    getdata(payload) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/calc2", payload).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (payload.action && res.data.url) {
            return this.$download(res.data.url, res.data.name);;
          }
          this.makedata(res.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makedata({ sources: headers, result }) {
      let columns = [];
      for (let i = 0; i < headers.length; i++) {
        let { from, to, dd } = headers[i];
        let header = `${from}-${to}`;
        columns.push({
          title: <div>
            <p>{header}</p>
            <p>{dd}</p>
          </div>,
          dataIndex: header,
          align: 'center',
          customRender: (value, record, index) => {
            if (record.index === 1) {
              let count12 = record[`${header}__count12`];
              let count12_1 = record[`${header}__count12_1`];
              let count12_2 = record[`${header}__count12_2`];
              let count30 = record[`${header}__count30`];
              let count30_1 = record[`${header}__count30_1`];
              let count30_2 = record[`${header}__count30_2`];
              return <div>
                <p><span style="color:#4caf50;">12({count12})</span>/<span style="color:#ff5052;">30({count30})</span></p>
                <p><span style="color:#4caf50;">{count12_1}车</span>/<span style="color:#ff5052;">{count30_1}头{count30_2}挂</span></p>
              </div>;
            }
            let time = record[`${header}__time`];
            let time1 = record[`${header}__time1`];
            let date1 = record[`${header}__date1`];
            let time2 = record[`${header}__time2`];
            let date2 = record[`${header}__date2`];
            let vehicle_number = record[`${header}__vehicle_number`];
            let vehicle_gnumber = record[`${header}__vehicle_gnumber`];
            let postroutecontent = record[`${header}__postroutecontent`];
            let otype = record[`${header}__otype`];
            let vtype = record[`${header}__vtype`];
            if (time) {
              if (vtype === '12') {
                if (otype === "临调") {
                  if (time1 && time2) {
                    return <div>
                      <p style="font-size:10px;">{date1}/{date2}</p>
                      <p><span title={date1}>{time1}</span>-<span title={date2}>{time2}</span></p>
                      <p style="font-size:10px;color:#4caf50;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                      <p style="font-size:10px;color:#ff5052;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                    </div>;
                  }
                  return <div>
                    <p style="font-size:10px;">{date1}</p>
                    <p><span title={date1}>{time1}</span></p>
                    <p style="font-size:10px;color:#4caf50;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                    <p style="font-size:10px;color:#ff5052;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                  </div>;
                }
                if (time1 && time2) {
                  return <div>
                    <p style="font-size:10px;">{date1}/{date2}</p>
                    <p><span title={date1}>{time1}</span>-<span title={date2}>{time2}</span></p>
                    <p style="font-size:10px;color:#4caf50;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                    <p style="font-size:10px;color:#4caf50;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                  </div>;
                }
                return <div>
                  <p style="font-size:10px;">{date1}</p>
                  <p><span title={date1}>{time1}</span></p>
                  <p style="font-size:10px;color:#4caf50;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                  <p style="font-size:10px;color:#4caf50;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                </div>;
              }
              else if (vtype === '30') {
                if (otype === "临调") {
                  if (time1 && time2) {
                    return <div>
                      <p style="font-size:10px;">{date1}/{date2}</p>
                      <p><span title={date1}>{time1}</span>-<span title={date2}>{time2}</span></p>
                      <p style="font-size:10px;color:#ff5052;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                      <p style="font-size:10px;color:#ff5052;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                      <p style="font-size:10px;">{vehicle_gnumber}</p>
                    </div>;
                  }
                  return <div>
                    <p style="font-size:10px;">{date1}</p>
                    <p><span title={date1}>{time1}</span></p>
                    <p style="font-size:10px;color:#ff5052;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                    <p style="font-size:10px;color:#ff5052;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                    <p style="font-size:10px;">{vehicle_gnumber}</p>
                  </div>;
                }
                if (time1 && time2) {
                  return <div>
                    <p style="font-size:10px;">{date1}/{date2}</p>
                    <p><span title={date1}>{time1}</span>-<span title={date2}>{time2}</span></p>
                    <p style="font-size:10px;color:#ff5052;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                    <p style="font-size:10px;color:#4caf50;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                    <p style="font-size:10px;">{vehicle_gnumber}</p>
                  </div>;
                }
                return <div>
                  <p style="font-size:10px;">{date1}</p>
                  <p><span title={date1}>{time1}</span></p>
                  <p style="font-size:10px;color:#ff5052;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                  <p style="font-size:10px;color:#4caf50;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                  <p style="font-size:10px;">{vehicle_gnumber}</p>
                </div>;
              }
              if (time1 && time2) {
                return <div>
                  <p style="font-size:10px;">{date1}/{date2}</p>
                  <p><span title={date1}>{time1}</span>-<span title={date2}>{time2}</span></p>
                  <p style="font-size:10px;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                  <p style="font-size:10px;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                </div>;
              }
              return <div>
                <p style="font-size:10px;">{date1}</p>
                <p><span title={date1}>{time1}</span></p>
                <p style="font-size:10px;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                <p style="font-size:10px;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
              </div>;
            }
            return value || "";
          },
        });
      }
      let gresult = _.groupBy(result, n => `${n.from}-${n.to}`);
      let length = 0;
      let list = [];
      let item = { index: 1 };
      for (let i = 0; i < headers.length; i++) {
        let { from, to } = headers[i];
        let header = `${from}-${to}`;
        let children = gresult[header] || [];
        length = Math.max(length, children.length);
        let count12 = 0, count12_1 = [], count12_2 = [];
        let count30 = 0, count30_1 = [], count30_2 = [];
        children.forEach(n => {
          if (n.vtype === '12') {
            count12++;
            count12_1.push(n.vehicle_number);
            if (n.vehicle_gnumber) {
              count12_2.push(n.vehicle_gnumber);
            }
          }
          else if (n.vtype === '30') {
            count30++;
            count30_1.push(n.vehicle_number);
            if (n.vehicle_gnumber) {
              count30_2.push(n.vehicle_gnumber);
            }
          }
        });
        item[`${header}__count12`] = count12;
        item[`${header}__count12_1`] = _.uniq(count12_1).length;
        item[`${header}__count12_2`] = _.uniq(count12_2).length;
        item[`${header}__count30`] = count30;
        item[`${header}__count30_1`] = _.uniq(count30_1).length;
        item[`${header}__count30_2`] = _.uniq(count30_2).length;
      }
      list.push(item);
      for (let i = 0; i < length; i++) {
        let item = {};
        for (let j = 0; j < headers.length; j++) {
          let { from, to } = headers[j];
          let header = `${from}-${to}`;
          let targets = gresult[header] || [];
          if (targets.length === 0 || !targets[i]) continue;
          let {
            postroutecontent,
            time1,
            date1,
            time2,
            date2,
            vehicle_number,
            vehicle_gnumber,
            otype,
            vtype,
          } = targets[i];
          item[`${header}__time`] = [time1, time2].filter(n => !!n).join('-');
          item[`${header}__time1`] = time1;
          item[`${header}__date1`] = date1;
          item[`${header}__time2`] = time2;
          item[`${header}__date2`] = date2;
          item[`${header}__vehicle_number`] = vehicle_number;
          item[`${header}__vehicle_gnumber`] = vehicle_gnumber;
          item[`${header}__postroutecontent`] = postroutecontent;
          item[`${header}__otype`] = otype;
          item[`${header}__vtype`] = vtype;
        }
        list.push(item);
      }
      this.data = [
        // headers.reduce((a, b) => ({ ...a, [b]: b, index: 1000 }), {}),
        ...list,
      ];
      this.columns = columns;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-header-column {
  font-size: 12px;
}

/deep/ .ant-table-row-cell-break-word {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-table-thead {
  font-size: 14px !important;
}

/deep/ .ant-collapse>.ant-collapse-item>.ant-collapse-header {
  padding: 6px 8px;
  padding-left: 30px;
}

/deep/ p {
  margin: 0;
  padding: 0;
}
</style>
